"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Box = require("./Box");
var _utils = require("./utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Tooltip = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Tooltip, _React$PureComponent);
  var _super = _createSuper(Tooltip);
  function Tooltip(props) {
    var _this;
    _classCallCheck(this, Tooltip);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "arrowGrap", 8);
    _defineProperty(_assertThisInitialized(_this), "position", function (d, t) {
      if (_this.props.position === 'l') return {
        left: d.left - t.width - _this.arrowGrap,
        top: d.top + (d.height - t.height) / 2
      };
      if (_this.props.position === 'r') return {
        left: d.left + d.width + _this.arrowGrap,
        top: d.top + (d.height - t.height) / 2
      };
      if (_this.props.position === 'b') return {
        left: d.left + (d.width - t.width) / 2,
        top: d.top + d.height + _this.arrowGrap
      };
      return {
        left: d.left + (d.width - t.width) / 2,
        top: d.top - t.height - _this.arrowGrap
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function (e) {
      var dimensions = e.target.getBoundingClientRect();
      var testDiv = document.createElement('div');
      testDiv.setAttribute('class', _this.className + ' -test');
      testDiv.appendChild(document.createTextNode(_this.props.title));
      document.body.appendChild(testDiv);
      var tooltipDimensions = testDiv.getBoundingClientRect();
      testDiv.remove();
      _this.setState({
        visible: true,
        style: _this.position(dimensions, tooltipDimensions)
      });
    });
    // onMouseOut = (e: any) => {}
    _defineProperty(_assertThisInitialized(_this), "onMouseOut", function (e) {
      return _this.setState({
        visible: false
      });
    });
    _this.state = {
      style: {},
      visible: false
    };
    _this.className = (0, _utils.clsNames)('un-tooltip', _this.props.className, !_this.props.noArrow && '-arrow_' + (_this.props.position || 't'));
    return _this;
  }
  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.map(this.props.children, function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          onMouseEnter: _this2.onMouseOver,
          onMouseLeave: _this2.onMouseOut
        });
      }), this.state.visible && /*#__PURE__*/React.createElement(_Box.PortalContainer, {
        children: /*#__PURE__*/React.createElement("div", {
          className: this.className,
          style: this.state.style
        }, this.props.title)
      }));
    }
  }]);
  return Tooltip;
}(React.PureComponent); //https://codepen.io/davidgilbertson/pen/ooXVyw
exports.default = Tooltip;